export type MenuItem = {
  text: string
  path: string
  subMenu?: MenuItem[]
  disabled?: boolean
  title?: string
  isExternal?: boolean
}

export type MenuList = MenuItem[]

export const menuList: MenuList = [
  {
    text: 'Cognitive Credit AI',
    path: '/ai',
  },
  {
    text: 'Companies',
    path: '/companies',
  },
  {
    text: 'Comparables',
    path: '/comparables',
    subMenu: [
      {
        text: 'Company',
        path: '/comparables/company',
      },
      {
        text: 'Sector',
        path: '/comparables/sector',
      },
      {
        text: 'Market',
        path: '/comparables/market',
      },
    ],
  },
  {
    text: 'DealConnect',
    path: '/dealconnect',
  },
  {
    text: 'Drive',
    path: '/drive',
  },
  {
    text: 'Text Search',
    path: '/text-search',
  },
]

export const adminMenuList: MenuList = [
  {
    text: 'Companies',
    path: '/admin/companies',
  },
  {
    text: 'Documents',
    path: '/admin/documents',
    subMenu: [
      {
        text: 'List',
        path: '/admin/documents',
      },
      {
        text: 'Tools',
        path: '/admin/documents/tools',
      },
    ],
  },
  {
    text: 'Batches',
    path: '/admin/batches',
    subMenu: [
      {
        text: 'List',
        path: '/admin/batches',
      },
      {
        text: 'Diff',
        path: '/admin/batches/diff',
      },
    ],
  },
  {
    text: 'Queries',
    path: '/admin/queries',
  },
  {
    text: 'Data Checks',
    path: '/admin/data-checks',
  },
]
